import React from "react";
import { CompleteIcon } from "../../../../../pages/ProviderRoom/components/CompleteIcon/CompleteIcon";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";

const StatusIcon = ({ capabilityStatus }) => {
  const isPendingStatus = capabilityStatus === "inactive";

  return (
    <div>
      {!isPendingStatus && (
        <CompleteIcon isCompleted={capabilityStatus === "active"} />
      )}
      {isPendingStatus && <CircularProgress size={"small"} color="gray1" />}
    </div>
  );
};

export default StatusIcon;
